import React from "react";
import IsPortrait from '../../helpers/WindowOrientation';
import logo from "../../../assets/svgs/avatr/avatr-wordmark.svg";

interface Props {
  title: string;
  subtitle: string;
  isInternalView: boolean;
  enableAnimations: boolean;
  setInternalView: (value: boolean) => void;
}

const BottombarView: React.FC<Props> = ({ enableAnimations, title, subtitle, isInternalView, setInternalView }) => {
  const isPortrait: boolean = IsPortrait();

  return (
    <div className="bottombar-menu-view">
      <div className="bottombar-view-content">

        <img className={`bottombar-view-logo`} src={logo} alt="" />

        <div className={`bottombar-view-options ${isPortrait ? 'portrait':''}`}>
          <div className={`bottombar-view-button-container ${!isInternalView ? 'selected':''}`} onClick={() => {if(enableAnimations) setInternalView(false)}}>
            <div className={`bottombar-view-button ${!isInternalView ? 'selected':''}`}>
              <div className={`bottombar-view-text ${!isInternalView ? 'selected':''}`}>Exterior</div>
            </div>
          </div>
          
          <div className={`bottombar-view-button-container ${isInternalView ? 'selected':''}`} onClick={() => {if(enableAnimations) setInternalView(true)}}>
            <div className={`bottombar-view-button ${isInternalView ? 'selected':''}`}>
              <div className={`bottombar-view-text ${isInternalView ? 'selected':''}`}>Interior</div>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
};

export default BottombarView;